import { COUPON_OFFERS, REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { RetrieveCoupon } from "../../common/utils/RetrieveCoupon";

function SuperCheapAutoTactical3Main() {
  const { loading, coupon } = RetrieveCoupon(COUPON_OFFERS.supercheapautotactical3);
  const redeemUrl = GLOBAL_CFG["supercheap-auto-tactical-3"].redeem.redeemUrl;

  return (
    <>
      {!loading && (
          <OnboardingPage
            partnerCfg={GLOBAL_CFG["supercheap-auto-tactical-3"]}
            redeemUrl={redeemUrl}
            coupon={coupon}
            rewardId={REWARD_OFFERING.supercheapautotactical3}
          />
      )}
    </>
  );
}

export default SuperCheapAutoTactical3Main;
